module.exports = __webpack_public_path__ + "img/yctiwy-5.4bb4f9de.jpg";